<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_stockin_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="批次号">
							<c-input name="batch_code"></c-input>
						</m-search-item>
						<m-search-item label="备注">
							<c-input name="remark"></c-input>
						</m-search-item>
						<m-search-item label="来源单据类型">
							<c-select name="source_order_types" :options="batchSourceOrderTypeDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="供应商">
							<c-select name="supplier_ids" async multiple @search="searchSupplier"></c-select>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_stockbatch_create')" v-lock="lock('b_stockbatch_create')" prepend-icon="tf-add" @click="$refs.stockbatchEdit.open()">创建库存批次</c-button>
					<c-button v-if="auth('b_stockbatch_export')" v-lock="lock('b_stockbatch_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<!-- <c-button v-if="auth('b_stockbatch_export')" v-lock="lock('b_stockbatch_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button> -->
					<!-- <c-button  prepend-icon="tf-import" @click="importData()">导入</c-button> -->
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_stockbatch_export')" v-lock="lock('b_stockbatch_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<!-- <c-button v-if="auth('b_stockbatch_export')" v-lock="lock('b_stockbatch_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button> -->
				</template>

				<template #otherOperate>
					<!-- <c-button prepend-icon="tf-import-record" @click="loadImportLogDetail()">导入记录</c-button> -->
				</template>

				<template #batch_code="{data}">
					<c-link @click="navigateTo(`/storage/stock/detail?in_batch_code=`+data.batch_code)">{{data.batch_code}}</c-link>
				</template>

				<!--来源单据类型-->
				<template #source_order_type="{data}">
					<c-state dict="batchSourceOrderTypeDic" :value="data.source_order_type"></c-state>
				</template>
				<!--关联单据-->
				<template #source_order_code="{data}">
					<order-link :type="data.source_order_type" :id="data.source_order_id" :code="data.source_order_code"></order-link>
				</template>
				
				<!--关联入库单号-->
				<template #storage_order_code="{data}">
					<order-link :type="4" :id="data.storage_order_id" :code="data.storage_order_code"></order-link>
				</template>
				
				<template #supplier_name="{data}">
					<span v-if="data.supplier_name">{{data.supplier_name}}</span>
					<span v-else>-</span>
				</template>
				
				<!-- <template #production_date="{data}">
					{{new Date(data.production_date).format('yyyy-MM-dd')}}
				</template> -->

				<c-table-column
					type="button"
					label="操作"
					width="210"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_stockbatch_edit')" v-lock="lock('b_stockbatch_edit')" icon="tf-edit" @click="$refs.stockbatchEdit.open(data)">编辑</c-table-button>
						<c-table-button icon="tf-detail" @click="navigateTo(`/storage/stock/detail?in_batch_code=`+data.batch_code)">查看库存明细</c-table-button>
						<c-table-button v-if="auth('b_stockbatch_delete')" v-lock="lock('b_stockbatch_delete')" icon="tf-trash" color="red" @click="remove(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--创建、编辑入库单信息弹窗-->
			<stockbatch-edit ref="stockbatchEdit" @resolve="$refs.view.update()"></stockbatch-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import stockbatchEdit from "@/pages/storage/stockbatch_edit.vue";

	export default {
		components: {stockbatchEdit},
		data() {
			return {
				workType: 49
			}
		},
		computed: {
			// 获取dictName选项数据
			...mapState(['batchSourceOrderTypeDic'])
		},
		methods: {
			
			/*******搜索【供应商】下拉框信息*****************/
			searchSupplier(keyword, resolve){
			    this.request({
			        url:'/system/options',
			        data: {
			            options_code:'SUPPLIER',
			            keyword: keyword
			        },
			        success:data => {
			            resolve(data);
			        }
			    })
			},

			/******删除***********/
			remove(data){
				this.$confirm({
					message:'确认删除库存批次【'+data.batch_code+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/stock_batch/delete',
							data: {batch_id: data.batch_id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/*******导入数据************/
			importData() {
				this.globalDialog('storageInfoSelector', {
					props: {
						workType: this.workType,
						title: '入库'
					}
				}, this.warehouseSelectorHandle);
			},

			/******加载导入业务日志列表**********/
			loadImportLogDetail() {
				//打开模板选择弹窗
				this.globalDialog('importLogDetail', {
					props: {
						workType: this.workType,
						view_id: this.view_id
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>